export const NAME = 'layout'
export const SET_ACCORDION = 'SET_LAYOUT_ACCORDION'
export const SET_TAB = 'SET_LAYOUT_TAB'